import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'precision'
})
export class PrecisionPipe implements PipeTransform {

    transform(value: any, precision: number) {

        if (value && !isNaN(value)) {
            value = +value;
        }

        if (typeof (value) === 'number') {
            const zero = 0;
            if (Math.abs(value) < Math.pow(10, -precision)) {
                return zero.toFixed(precision);
            }
            return value.toFixed(precision);
        }
        return value;
    }
}
